// extracted by mini-css-extract-plugin
export default {"ReviewRating":"ReviewRating_ReviewRating__OGQ4Z","ReviewRating__image":"ReviewRating_ReviewRating__image__MjA3Y"};